<template>
	<div class="selectSignatory">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center :close-on-click-modal="false">
			<div class="center">
				<el-form ref="form" class="lz-seach-animation" inline @submit.native.prevent>
					<el-form-item label="签署方名称">
						<el-input v-model="seachData.keyword" placeholder="签署方名称" @keyup.enter.native="seachInput"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" plain size="small" type="primary" @click="seachInput">搜索</el-button>
					</el-form-item>
				</el-form >
				<el-table :data="tableData" style="width: 100%" border @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column align="center" label="创建时间" prop="createDate" width="140"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="签约方名称" prop="partnerName" width="170"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="证件类型" prop="identTypeCode" width="170">
						<template slot-scope="scope">
							{{computerDocumentType(scope.row.identTypeCode)}}
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="证件号码" prop="identNo"></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="邮箱" prop="email" ></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="联系人手机号" prop="phone" width="180">
						<template slot-scope="scope">
							<el-input v-model="scope.row.phone" @input="changeInput($event,scope.row)" placeholder="请输入联系人手机号" :class="(!scope.row.phone&&scope.row.isChoice==true&&selectList.length>0 || scope.row.isRed==true)?'lz-input':''"></el-input>
						</template>
					</el-table-column>
					
				</el-table>
				<el-pagination :current-page="page.pageNum" :page-size="page.pageSize" :page-sizes="[10,20,30,40,50]"
				:total="page.total" class="lz-el-pagination" layout="total, sizes, prev, pager, next, jumper"
				@current-change="handleCurrentChange"></el-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelFn">取 消</el-button>
				<el-button type="primary" :disabled="selectList.length==0"  @click="submitFn">确 定</el-button>
			</span>
		</el-dialog>
		
		
	</div>
</template>

<script>
	let that 
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api','documentTypeList']),
			//计算证件类型
			computerDocumentType(){
				return (code)=>{
					let item= this.documentTypeList.find(item=>item.value==code)
					return item.label
				}
			}
		},
		name: 'selectSignatory',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			title: {
				type: String,
				default: '选择'
			},
			enterpriseId:{
				type: String,
				default: ''
			},
			//已选择的签署方
			oldSelectList:{
				type: Array,
				default: ()=>{
					return []
				}
			},
		},
		data() {
			return {
				dialog:{
					show:false,
				},
				tableData:[],
				//搜索
				seachData: {
					keyword: '' //关键词
				},
				page:{
					page: true,
					pageNum: 1,
					pageSize: 10,
					total:0
				},
				selectList:[],//已经选择的
			}
		},
		mounted() {
			that =this
		},
		methods: {
			selectFn(row){
				this.selectList=[row]
				this.submitFn()
			},
			cancelFn(){
				this.dialog.show=false
				this.cancel()
			},
			//确定
			submitFn(){
				let onoff=false
				this.selectList.forEach(item=>{
					if(item.phone==''){
						onoff=true
						this.$message.warning('联系人手机号必填项')
						return
					}else if(!this.$lizhao.test.mobile(item.phone)){
						onoff=true
						this.$message.warning('手机号格式不正确')
						return
					}
				})
				if(onoff)return
				this.dialog.show=false
				this.confirm(this.selectList)
			},
			changeInput(e,row){
				if(e&&!this.$lizhao.test.mobile(e)){
					row.isRed=true
				}else{
					row.isRed=false
				}
			},
			//多选
			handleSelectionChange(val){
				this.tableData.forEach(item=>{
					item.isChoice=false
				})
				this.selectList=val
				val=val.map(row=>{
					row.isChoice=true
					return row
				})
				
			},
			seachInput(){
				//获取签署方列表
				this.findList()
			},
			show(data){
				this.dialog.show=true
				//获取签署方列表
				this.findList()
			},
			findList(){
				let req={
					...this.page,
					...this.seachData,
					enterpriseId:this.enterpriseId
				}
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_contract_findEnterpriseLiaisonList,req,(res)=>{
					if(res.code==200&&res.data&&res.data.list){
						// this.tableData=res.data.list.map(item=>{
						// 	item.phone=''
						// 	return item
						// })
						this.tableData=res.data.list.filter(item=>{
							item.phone=''
							if(!this.oldSelectList.includes(item.id)){
								return item
							}
						})
						this.page.total=res.data.total
					}else{
						this.tableData=[]
						this.page.total=0
					}
				})
			},
			handclose(){
				this.close()
			},
			handleCurrentChange(val){
				that.page.pageNum = val;
				that.findList()
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body{
		padding:20px 20px 0px
	}
	/deep/ .lz-input .el-input__inner{
		border-color: red;
	}
	.selectSignatory {
		.center{
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/selectSignatory/selectSignatory.vue